package co.maytes.standupbot.dashboard.features.analytics

import co.maytes.standupbot.dashboard.components.motion.ViewPhase

fun <T> ResourceState<T>.viewPhase(isEmpty: (T) -> Boolean = { false }): ViewPhase = when (this) {
    ResourceState.Idle, ResourceState.Loading -> ViewPhase.Loading
    is ResourceState.Error -> ViewPhase.Error
    is ResourceState.Loaded -> if (isEmpty(value)) ViewPhase.Empty else ViewPhase.Ready
}

object AnalyticsPhase {
    fun of(
        costs: ResourceState<*>,
        velocity: ResourceState<*>,
        participation: ResourceState<*>,
        hasAnyData: Boolean,
    ): ViewPhase {
        val states = listOf(costs, velocity, participation)
        return when {
            states.all { it is ResourceState.Loaded<*> } -> if (hasAnyData) ViewPhase.Ready else ViewPhase.Empty
            states.any { it.isPending() } -> ViewPhase.Loading
            else -> ViewPhase.Error
        }
    }
}
